import { FetcherContext } from '@rogu/fetch/dist/base';

import { GetOTTResponse, User } from './userEntity';

import { getOneTimeTokenExn } from '@/__generated__/__services__/auth/Auth';
import {
  getUserDataByTokenExn,
  GetUserDataByTokenResponse,
  GetUserDataByTokenError,
} from '@/__generated__/__services__/user/User';

function getOttExn(context?: FetcherContext): Promise<GetOTTResponse> {
  return getOneTimeTokenExn(context).then((response) => ({
    oneTimeToken: response.oneTimeToken,
  }));
}

function fromUserResponseToUserEntity(user: GetUserDataByTokenResponse): User {
  return {
    name: user.name,
    profilePic: user.profile_pic_full_domain || undefined,
    uniqueOrderCode: user.unique_order_code || '',
    role: user.role,
    cellphoneNumber: user.cellphone_number,
  };
}

function getUserDataByToken(context?: FetcherContext): Promise<Array<User>> {
  return getUserDataByTokenExn(context).then((response) =>
    response.map(fromUserResponseToUserEntity),
  );
}

export type { GetUserDataByTokenError };
export { getUserDataByToken, getOttExn };
